var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seckillNoFund-component",style:({'height': _vm.height + 'px'})},[_c('i',{staticClass:"ico ico-icon_59"}),_c('div',{staticClass:"tips"},[_vm._v("活动不存在")])])}
var staticRenderFns = []

export { render, staticRenderFns }